module.exports = __webpack_public_path__ + "img/time-to-relax.f33e1b23.jpg";